// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2S22n","row":"Node_row__2I7dh","label":"Node_label__1k6zO","footer":"Node_footer__3lJVO"};